/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TenantListRequest {
    getFixupPrototypeFunction() { return TenantListRequest.fixupPrototype; }

    static newInstance(model: Partial<TenantListRequest>): TenantListRequest {
        let obj = Object.assign(new TenantListRequest(), model);
        TenantListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TenantListRequest>): TenantListRequest {
        if (!model) return null;
        return TenantListRequest.newInstance(<TenantListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TenantListRequest) {
        if (!obj) return;

        models.TenantListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TenantListRequest): boolean {
        Object.setPrototypeOf(obj, TenantListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.TenantFilters.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.TenantDetailsSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.TenantDetailsSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.TenantFilters;

}
